import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TopicService } from '../topic.service';
import { GeneralComponent } from '../../General/g.component';

@Component({
  selector: 'app-input-field',
  templateUrl: './input-field.component.html',
  host: { '(window:keydown)': 'onKeyDown($event)', '(window:keyup)': 'onKeyUp($event)' },
  styleUrls: ['../topic-style.css', './input-field.component.css']
})
export class InputFieldComponent extends GeneralComponent{


  @Input('text')
  set text(value: string) {
    if(value){
    this.dText = value.split("");
    }
  }

  get text() {
    return this.dText.join("");
  }

  @Input() packages: number = 1;

  @Output() selectedOut = new EventEmitter<number>();
  @Output() newPair = new EventEmitter<string[]>();

  dText: string[];

  selected = 0;

  showTip = true;



  constructor(protected topicService: TopicService) {
    super(topicService);
  }

  /** handle the key down event by inserting the correct letter and shifting the caret */
  onKeyDown(event) {
    if (!this.isFocused()) {
      return;
    }
    let backspace = 8;
    if (event.keyCode == backspace && this.selected > 0){
      this.selected--;
      while (this.dText[this.selected] === " " ) {
        this.selected -= 1;
      }
      this.dText[this.selected] = "#";
      this.newPair.emit(["-",this.selected.toString()])
    }
    if (event.keyCode == 37 && this.selected > 0) {
      this.selected -= 1;
      while (this.dText[this.selected] === " ") {
        this.selected -= 1;
      }
    }

    if (event.keyCode == 39 && this.selected < this.dText.length - 1) {
      this.selected++;
      while (this.dText[this.selected] === " ") {
        this.selected++;
      }
    }
    if (((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 48 && event.keyCode <= 57)) && this.selected < this.dText.length) {
      this.dText[this.selected] = event.key;
      this.newPair.emit([this.dText[this.selected], this.selected.toString()])
      this.selected++;
      while (this.dText[this.selected] === " ") {
        this.selected++;
      }
    }
  }

  /** normalize the text on key up */
  onKeyUp() {
    if (document.activeElement.tagName == "INPUT" || document.activeElement.tagName == "TEXTAREA") {
      return;
    }
    this.normalizeText();
    this.selectedOut.emit(Math.floor((this.selected - this.text.substring(0, this.selected).split(" ").length+1) / this.packages + this.text.substring(0, this.selected).split(" ").length-1));

  }

  /** set the caret on click */
  onClick(position: number) {
    if (document.activeElement.tagName == "INPUT" || document.activeElement.tagName == "TEXTAREA") {
      return;
    }
    this.selected = position;
    while (this.dText[this.selected] == " ") {
      this.selected++;
    }
    this.selectedOut.emit(Math.floor((this.selected - this.text.substring(0, this.selected).split(" ").length+1) / this.packages + this.text.substring(0, this.selected).split(" ").length-1));
  }

  /** normalize the text to only contain alphanumeric */
  normalizeText() {
    this.text = this.dText.join("");
    this.text = this.text.toUpperCase().replace(/[^A-z0-9 -]/gi, "#");
    this.dText = this.text.split("");
  }

  /** returns the current text */
  getText(): string {
    this.text = this.dText.join("");
    return this.text;
  }

  /** check it the input field is focused */
  isFocused():boolean{
    if (document.activeElement.tagName == "INPUT" || document.activeElement.tagName == "TEXTAREA") {
      return false;
    }
    return true;
  }

  /** show the tip about the input field? */
  showTipTS(tip: string): boolean{
    return this.topicService.showTip(tip);
  }

}
